// export const API_HOST = "http://localhost:3007/api/v1/";

export const API_HOST = "https://tint.toothlens.com/api/v1/";

// export const API_HOST = "https://tint.toothlens.com/api/v1/";

// export const API_HOST = "https://sim.toothlens.com/api/v1/";
